import React from 'react'

type Props = {
  children: React.ReactNode
  tag?: keyof JSX.IntrinsicElements
  className?: string
}

export const KTitle = ({ children, tag: Tag = 'h2', className }: Props) => {
  if (!children) return null

  return <Tag className={className}>{children}</Tag>
}
